import { AfterViewInit, Component, OnInit } from '@angular/core';
import {TdoClientConfigurationModel} from '../../../models/clients/tdo-client-configuration.model';
import {ClientLocationDataModel} from '../../../models/clients/client-location-data.model';
import {OperatoriesService} from '../operatories/operatories.service';
import {Globals} from '../../../globals';
import {DialogService} from '../../../services/dialog.service';
import {MatSnackBar} from '@angular/material/snack-bar';
import {MatDialog} from '@angular/material/dialog';
import {DeviceConfigurationModel} from '../../../models/configuration/device-configuration.model';
import {DevicesService} from './devices.service';
import {EnumValidValueItemModel} from '../../../models/enum/enum-valid-value-item.model';
import {StaticDataService} from '../../../services/static-data.service';
import {DeviceParameters, PrinterParameters} from '../../../models/configuration/workstation-devices-configuration.model';
import {TdoDropdownChange} from '../../../tdo-controls/common/tdo-dropdown-v2/models/tdo-dropdown-change';

@Component({
  selector: 'app-devices',
  templateUrl: './devices.component.html',
  styleUrls: ['./devices.component.scss']
})
export class DevicesComponent implements OnInit, AfterViewInit {
  clientList: TdoClientConfigurationModel[];
  locationList: ClientLocationDataModel[];
  devicesList: DeviceConfigurationModel[];
  isConfirmDisabled = true;
  selectedClient: TdoClientConfigurationModel;
  selectedLocation: ClientLocationDataModel;
  selectedDevice: DeviceConfigurationModel;

  editedDevices: DeviceConfigurationModel[] = [];
  isLoading = true;
  selectedPrinterName: string;
  isPrinter = false;

  devicesTypesEnums: EnumValidValueItemModel[];
  devicesTwainEnums: EnumValidValueItemModel[];
  devicesSBEnums: EnumValidValueItemModel[];

  enumDeviceTwain: string = '00000261-1000-0000-0000-000000000001';
  enumDevicePrinter: string = '00000B62-1000-0000-0000-000000000007';

  public deviceParam: DeviceParameters;
  public printerParam: PrinterParameters;

  constructor(private devsService: DevicesService,
              private opsService: OperatoriesService,
              private staticDataService: StaticDataService,
              private globals: Globals,
              private dialogService: DialogService,
              private snackbar: MatSnackBar,
              private dialog: MatDialog) { }

  async ngAfterViewInit() {
  }
  ngOnInit(): void {
    this.selectedPrinterName = '';
    this.enumInit();
    this.opsService.getClients().subscribe(data => {
      this.clientList = data;
      const currentClient = this.clientList.find(p => p.TDOCID.toString() === this.globals.TDOCID);
      if (currentClient) {
        this.selectedClient = currentClient;
      } else {
        this.selectedClient = this.clientList[0];
      }

      this.opsService.getClientLocations(this.selectedClient.TDOCID.toString()).subscribe(ldata => {
        this.locationList = ldata;

        if (this.locationList.length > 0) {
          const currentLoc = this.locationList.find(p => p.LOCID.toString() === this.globals.LOCID);
          if (currentLoc) {
            this.selectedLocation = currentLoc;
          } else {
            this.selectedLocation = this.locationList[0];
          }
          const evt = new TdoDropdownChange();
          evt.value = this.selectedLocation;
          evt.isUserInput = true;
          this.onChangeLoc(evt);
        }
        this.isLoading = false;
      });

    }, err => {
      console.log(err);
      this.isLoading = false;
    });
  }

  enumInit() {

    if (this.staticDataService.isReady) {
      this.devicesTypesEnums = this.staticDataService.getValidValueItemsByValidValueName('enumDeviceType');
      this.devicesTwainEnums = this.staticDataService.getValidValueItemsByValidValueName('enumDeviceTWAIN');
      this.devicesSBEnums = this.staticDataService.getValidValueItemsByValidValueName('enumDeviceSB');
    } else {
      this.staticDataService.validValuesReadyEvent.subscribe({
        complete: () => {
          this.devicesTypesEnums = this.staticDataService.getValidValueItemsByValidValueName('enumDeviceType');
          this.devicesTwainEnums = this.staticDataService.getValidValueItemsByValidValueName('enumDeviceTWAIN');
          this.devicesSBEnums = this.staticDataService.getValidValueItemsByValidValueName('enumDeviceSB');
        }
      });
    }
  }

  onChangeClient(e: TdoDropdownChange): void {
    if (!e.isUserInput) {
      return;
    }
    this.selectedClient = e.value;
    this.isLoading = true;
    this.opsService.getClientLocations(this.selectedClient.TDOCID.toString()).subscribe(ldata => {
      this.locationList = ldata;
      this.selectedLocation = null;

      if (this.locationList.length > 0) {
        this.selectedLocation = this.locationList[0];
        const evt = new TdoDropdownChange();
        evt.value = this.selectedLocation;
        evt.isUserInput = true;
        this.onChangeLoc(evt);
      }
      this.isLoading = false;
    }, err => {
      console.log(err);
      this.isLoading = false;
    });

  }
  onChangeLoc(e: TdoDropdownChange) {
    if (!e.isUserInput) {
      return;
    }
    this.selectedLocation = e.value;
    this.isLoading = true;
    this.selectedDevice = null;
    this.devsService.getDevices(this.selectedLocation.LOCID.toString()).subscribe(ddata => {
    // this.devsService.getDevices('94C93CED-755F-431A-AA32-9B253B8A40D5').subscribe(ddata => {
      this.devicesList = ddata;
      this.selectedDevice = this.devicesList[0];
      this.printerInfo();
      // check if using twain
      this.isLoading = false;
    }, err => {
      console.log(err);
      this.isLoading = false;
    });
  }
  onNew($event: any) {
    this.addDevice();
  }
  onSave($event: any) {
    this.isLoading = true;
    this.devsService.saveDevices(this.editedDevices).subscribe((res) => {
      if (res) {
        for (const r of res) {
          const currentIdx = this.devicesList.findIndex(p => p.Name === r.Name);
          if (currentIdx > -1) {
            this.devicesList[currentIdx] = r;
          } else {
            this.devicesList.push(r);
          }
        }
        this.selectedDevice = res[0];
      }

      this.devicesList.sort((a, b) => a.Name.localeCompare(b.Name));

      this.snackbar.open('Devices saved.', '', {duration: 5000});
      this.isLoading = false;
      this.editedDevices = [];
    });

  }
  addDevice() {
    this.isPrinter = false;
    const device = new DeviceConfigurationModel();
    device.Name = 'New Device';
    device.LOCID = this.selectedLocation.LOCID;
    device.ParametersJSON = '';
    this.devicesList.unshift(device);
    this.selectedDevice = device;
  }
  isDeviceItemSelected(device: DeviceConfigurationModel) {
    return this.selectedDevice === device;
  }

  onDeviceChanged(device: DeviceConfigurationModel) {
    this.selectedDevice = device;
    this.printerInfo();
  }

  onDeleteDevice(device: DeviceConfigurationModel) {
    this.dialogService.openConfirmDialog('Are you sure you want to delete ' + device.Name + '?').subscribe((res) => {
      if (res) {
        if (!device.DeviceID) {
          const idx1 = this.devicesList.findIndex(q => q.Name === device.Name);
          this.devicesList.splice(idx1, 1);
        } else {
          this.devsService.deleteDevice(device).subscribe((res1) => {
            //
            const idx = this.devicesList.findIndex(p => p.DeviceID === device.DeviceID);
            if (idx > -1) {
              this.devicesList.splice(idx, 1);
              this.selectedDevice = this.devicesList[0];
              this.printerInfo();
            } else {
              const idx1 = this.devicesList.findIndex(q => q.Name === device.Name);
              this.devicesList.splice(idx1, 1);
            }
          });
        }
      }
    });
  }

  onModelChange(selectedDevice: DeviceConfigurationModel) {
    selectedDevice.ParametersJSON = this.stringifyPrinterName(this.selectedPrinterName);
    if (selectedDevice.enumDeviceTypeID === this.enumDeviceTwain) {
      this.getDeviceTypeById(selectedDevice.enumDeviceTWAINID);
    }
    if (!this.editedDevices.includes(selectedDevice)) {
      this.editedDevices.push(selectedDevice);
    }
  }
  getDeviceTypeById(deviceId: string) {
    const val = this.devicesTypesEnums.find(p => p.ValidValueItemId === deviceId);
    if (val) {
      return val;
    }
    else {
      return null;
    }
  }
  getDeviceTWAINById(deviceTwainId: string) {
    return this.devicesTwainEnums.find(p => p.ValidValueItemId === deviceTwainId);
  }
  getDeviceSBById(deviceSBId: string) {
    return this.devicesSBEnums.find(p => p.ValidValueItemId === deviceSBId);
  }
  onSelectedDevice(value: string) {
    console.log('onSelectedDevice ', value);

    this.selectedDevice.enumDeviceTypeID = value;
    this.onModelChange(this.selectedDevice);
  }
  onSelectedTwainDevice(value: string) {
    console.log('onSelectedTwainDevice ', value);
    this.selectedDevice.enumDeviceTWAINID = value;
    this.onModelChange(this.selectedDevice);
  }
  onSelectedSBDevice(value: string) {
    console.log('onSelonSelectedSBDeviceectedDevice ', value);
    this.selectedDevice.enumDeviceSBID = value;
    this.printerInfo();
    this.onModelChange(this.selectedDevice);
  }

  getPrinterNameFromJSON(paramJson: string) {
    this.printerParam = JSON.parse(paramJson);
    return this.printerParam.printerName;
  }

  stringifyPrinterName(printer: string) {
    const printerParam = new PrinterParameters();
    printerParam.printerName = printer;
    return JSON.stringify(printerParam);
  }

  printerInfo() {
    this.selectedPrinterName = '';
    if (this.selectedDevice.enumDeviceSBID.toLowerCase() === this.enumDevicePrinter.toLowerCase()) {
      this.isPrinter = true;
    }
    else {
      this.isPrinter = false;
    }
    if (this.selectedDevice.ParametersJSON != null && this.selectedDevice.ParametersJSON !== '') {
      this.selectedPrinterName = this.getPrinterNameFromJSON(this.selectedDevice.ParametersJSON);
    }

  }

}
